import { UNIT_FACTORS_TO_METRES } from "./meshLoad";

export type LengthUnit = "mm" | "cm" | "m" | "in";
export const isLengthUnit = (u: string): u is LengthUnit => u in UNIT_FACTORS_TO_METRES;

export function convertLength(v: number, from: LengthUnit, to: LengthUnit): number {
  return (v * UNIT_FACTORS_TO_METRES[from].f) / UNIT_FACTORS_TO_METRES[to].f;
}

export function distance3(a: ArrayLike<number>, b: ArrayLike<number>): number {
  return Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]);
}

const trim = (n: number) => (n !== 0 && Math.abs(n) < 0.01 ? n.toExponential(2) : n.toLocaleString("en-US", { maximumFractionDigits: n >= 100 ? 1 : 3 }));

/** The unit shown next to the main one: inches for metric units, millimetres for inches. */
export const otherUnit = (u: LengthUnit): LengthUnit => (u === "in" ? "mm" : "in");

/** "12.5 mm (0.492 in)": a length in the model's unit with the same length in inches (or millimetres, for an inch model). */
export function formatLength(v: number, unit: LengthUnit): string {
  const o = otherUnit(unit);
  return `${trim(v)} ${unit} (${trim(convertLength(v, unit, o))} ${o})`;
}

/** "2 × 2 × 2 mm (0.079 × 0.079 × 0.079 in)". */
export function formatSize(size: number[], unit: LengthUnit): string {
  const o = otherUnit(unit);
  return `${size.map(trim).join(" × ")} ${unit} (${size.map((s) => trim(convertLength(s, unit, o))).join(" × ")} ${o})`;
}
